import ivclass from '@invideoio/web-shared/Modules/IVClass';
import Feature from './Feature';
import {
  AddonSubscriptionPlan,
  UsageFeature,
  UsageQuota,
} from 'src/types/pricing.types';
import { useAiCredits } from '../AiCredits';
import { useContext } from 'react';
import { StateContext } from '@store/store';

interface FeaturesProps {
  featuresList: UsageFeature[];
  usageQuota: UsageQuota;
  planKey: string;
  isYearlyDuration: boolean;
  addonPlan?: AddonSubscriptionPlan;
  renderPropsBottom?: () => JSX.Element;
}

const FeaturesList = (props: FeaturesProps) => {
  const {
    featuresList,
    renderPropsBottom,
    planKey,
    usageQuota,
    isYearlyDuration,
    addonPlan,
  } = props;
  const globalState = useContext(StateContext);

  const { seats } = globalState;

  const { aiCredits, aiCreditsPrice } = useAiCredits({
    planKey,
    isYearlyDuration,
    addonPlan,
  });

  const baseGenerativeCredits =
    seats[planKey] * (usageQuota.ai_credits_v2 || 0);

  const totalGenerativeCredits = baseGenerativeCredits + aiCredits;

  return (
    <div
      className={ivclass('iv-py-10', 'md:iv-ml-15 sm:iv-ml-8', 'iv-flex-grow')}
    >
      {featuresList.map((feature, index) => {
        return (
          <Feature
            key={index}
            feature={feature}
            planKey={planKey}
            usageQuota={usageQuota}
            totalGenerativeCredits={totalGenerativeCredits}
            addOnQuota={addonPlan?.usage_quota}
          />
        );
      })}

      {typeof renderPropsBottom === 'function' && renderPropsBottom()}
    </div>
  );
};

export default FeaturesList;
